import React from 'react';
import {isEqual} from 'lodash/lang';
import {SelectSearchBase} from 'components/Forms/FormBases';

class SelectFieldName extends React.Component {
  static defaultProps = {
    name: 'field_value',
    placeholder: 'Select or Search by Name',
    cacheOptions: true,
    defaultOptions: true,
    filters: {},
    onChange: () => {},
    getOptionLabel: (option) => option.field_value,
    getOptionValue: (option) => option.field_value,
  };

  constructor(props) {
    super(props);

    this.state = {
      options: [],
      value: props.defaultValue || '',
      inputValue: '',
    };
  }

  componentDidMount() {
    this._isMounted = true;

    const {defaultOptions} = this.props;

    if (defaultOptions) this.loadOptions();
  }

  componentDidUpdate(prevProps, prevState) {
    const {inputValue} = this.state;

    if (!isEqual(prevProps.filters, this.props.filters)) {
      this.setState(
        {
          value: '',
          options: [],
        },
        this.loadOptions
      );
    }

    if (!isEqual(prevState.inputValue, inputValue)) {
      this.loadOptions();
    }
  }

  loadOptions = async () => {
    // const {inputValue} = this.state;
    const {isDisabled} = this.props; // filters
    if (isDisabled) return false;

    await this.setState({isLoading: true});
    // const {data} = await getMappingsByFieldName({
    //   ...filters,
    //   search: inputValue,
    //   order: 'ASC',
    //   order_by: 'field_name',
    // });

    if (!this._isMounted) return false; // Check Mounted

    this.setState({
      options: [],
      isLoading: false,
    });
  };

  render() {
    const {value, defaultOptions, filters, onChange, ...rest} = this.props;

    return (
      <SelectSearchBase
        value={this.state.value}
        options={this.state.options}
        isLoading={this.state.isLoading}
        getOptionLabel={(option) => option.field_value}
        getOptionValue={(option) => option.field_value}
        onChange={(data) => this.setState({value: data}, onChange(data))}
        onInputChange={(value) => this.setState({inputValue: value})}
        loadOptions={this.loadOptions}
        {...rest}
      />
    );
  }
}

export default SelectFieldName;
